import type { RibbonControlGroupDefinitionSLR, RibbonTabDefinitionBase } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import { constructKeytip, SingleLine } from 'owa-command-ribbon';
import loc from 'owa-localize';
import { getMailRibbonConfigStore } from 'owa-mail-ribbon-store/lib/store/store';
import { folder_tab as Strings_folder_tab } from 'owa-mail-ribbon-utils/lib/ribbon_mail_strings.locstring.json';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { getUniqueTabId } from 'owa-mail-ribbon-utils/lib/getUniqueTabId';
import { type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { getTabGroups } from '../../../util/getTabGroups';
import { getSLRFolderTabControlDefinition } from './getSLRFolderTabControlDefinition';

const getSLRFolderTab: (props: ReadOnlyRibbonControlDefProps) => RibbonTabDefinitionBase =
    owaComputedFn(function getSLRFolderTab(
        props: ReadOnlyRibbonControlDefProps
    ): RibbonTabDefinitionBase {
        return {
            type: SingleLine,
            id: getUniqueTabId(17, undefined /* editorId */, props.itemId, props.isPopout),
            title: loc(Strings_folder_tab),
            controlGroups: { type: SingleLine, groups: getFolderTabGroups(props) },
            initialScalingSteps: [],
            scalingSteps: [],
            keytipProps: constructKeytip([], 17, true /* hasMenu */),
        };
    });

const getFolderTabGroups: (
    props: ReadOnlyRibbonControlDefProps
) => RibbonControlGroupDefinitionSLR[] = owaComputedFn(function getFolderTabGroups(
    props: ReadOnlyRibbonControlDefProps
): RibbonControlGroupDefinitionSLR[] {
    let folderTabGroups: RibbonControlGroupDefinitionSLR[] = new Array();

    folderTabGroups = getTabGroups(
        17,
        getMailRibbonConfigStore(props.mailboxInfo).singleline.folderTab.layout,
        getSLRFolderTabControlDefinition,
        props
    );

    return folderTabGroups;
});

export default getSLRFolderTab;
